import api from '../../../../services/api'
import store from '../../../../store'

import type from './types'
import {
  DocumentsToGet,
  DocumentToPost,
  Document_DocumentTypesToGet,
  DocumentsToGet_providerDocumentFields,
  DocumentEditResponse,
  DocumentFileActionType,
  DocumentStatusType,
  DocumentEmailToPost,
  DocumentMissingEmailToPost
} from '../../models/interfaces'
import { ActionType } from '../../../../models/types'

import { dateCurrent } from '../../../../utils'

const baseUrl = process.env.REACT_APP_PROVIDERDOCUMENT

export const setSelectedDocumentType = async (params: object) => {
  try {
    store.dispatch(setSelectedDocumentTypeStore(params))
    return true
  } catch (err) {
    console.log(err)
    return false
  }
}
const setSelectedDocumentTypeStore = (data: object): ActionType => ({
  type: type.SET_SELECTED_DOCUMENTS_TYPE,
  payload: data
})

const setDocuments = (data: any): ActionType => ({
  type: type.SET_LIST_DOCUMENTS,
  payload: data
})

const setDocumentsMissing = (data: any): ActionType => ({
  type: type.SET_LIST_DOCUMENTS_MISSING,
  payload: data
})

const setLoading = (data: boolean): ActionType => ({
  type: type.SET_LOADING_DOCUMENTS,
  payload: data
})

const setTotalDocuments = (data: number): ActionType => ({
  type: type.SET_TOTAL_DOCUMENTS,
  payload: data
})

export const sendDocument = async (params: DocumentToPost) => {
  try {
    await api.post(`${baseUrl}/providerDocuments`, params)
    return true
  } catch (err) {
    console.log(err)
    return false
  }
}

export const getDocuments = async (id: string | undefined,page: number | null) => {
  try {
    let params = '';

    store.dispatch(setLoading(true));

    if (id !== 'all' && id !== '0') params = id ? '/?providerId=' + id : '';
    if (page !== null) params += params ? `&page=${page}` : `/?page=${page}`;

    const { data } = await api.get(`${baseUrl}/providerDocuments${params}`);

    let documents: DocumentsToGet[] = data.data.providerDocuments
    documents = documents.filter(object => object.active !== false);

    if (documents && documents.length > 0) {
      store.dispatch(setTotalDocuments(data.data.total))
      store.dispatch(setDocuments(documents))
    }

  } catch (err) {
    console.log(err)
  }finally {
      store.dispatch(setLoading(false))
  }
}

export const gatDocumentsMissing = async (idProvider:number = 0) => {
  try {
    let providerDocumentMissing: DocumentsToGet[];
    store.dispatch(setLoading(true))

    const { data } = await api.get(`${baseUrl}/providerDocuments/missing/${idProvider}`);

    providerDocumentMissing = data.data.providerDocumentMissing;
    if (providerDocumentMissing.length > 0) {
      return store.dispatch(setDocumentsMissing(providerDocumentMissing));
    }
    return store.dispatch(setDocumentsMissing(providerDocumentMissing));
  } catch (err) {
    console.log(err)
  } finally {
    store.dispatch(setLoading(false))
  }
}

export const getDocumentById = async (id: number) => {
  store.dispatch(setLoading(true))
  try {
    const {
      data: {
        data: { providerDocument }
      }
    }: any = await api.get(baseUrl + `/providerDocuments/${id}`)

    const providerDocumentFields: Document_DocumentTypesToGet = mapperDocumentEdit(
      providerDocument
    )

    const Document: DocumentEditResponse = {
      Document: {
        id: providerDocument.id,
        providerId: providerDocument.providerId,
        fileName: providerDocument.path,
        description: Boolean(providerDocument.description)
          ? providerDocument.description
          : '',
        observation: Boolean(providerDocument.observation)
          ? providerDocument.observation
          : '',
        expirationDate: Boolean(providerDocument.expirationDate)
          ? dateCurrent('pt-BR', providerDocument.expirationDate)
          : '',
        status: providerDocument.status,
        active: providerDocument.active,
        message: providerDocument.message,
      },
      providerDocumentFields
    }

    return Document
  } catch (err) {
    throw err
  } finally {
    store.dispatch(setLoading(false))
  }
}

const mapperDocumentEdit = (
  data: DocumentsToGet
): Document_DocumentTypesToGet => ({
  id: data.documentTypeId,
  name: data.title,
  active: data.active,
  requiredDescription:data?.documentType?.requiredDescription,
  documentTypeFields: data.providerDocumentFields.map(
    (element: DocumentsToGet_providerDocumentFields) => ({
      id: element.documentTypeField.id,
      documentTypeId: data.documentTypeId,
      description: element.documentTypeField.description,
      fieldType: element.documentTypeField.fieldType,
      allowsNull: element.documentTypeField.allowsNull,
      active: element.documentTypeField.active,
      answer: {
        id: element.id,
        documentTypeFieldId: element.documentTypeField.id,
        value: element.value
      }
    })
  )
})

export const editDocumentFields = async (params: DocumentToPost) => {
  params.fileAction = params.fileAction ?? DocumentFileActionType.Keep
  if (
    params.fileAction === DocumentFileActionType.Keep &&
    params.file != null &&
    params.file === ''
  ) {
    params.fileAction = DocumentFileActionType.Change
  }

  try {
    await api.put(baseUrl + '/providerDocuments', params)
    return true
  } catch (err: any) {
    console.log(err.response.data.error)
    return false
  }
}

export const deleteDocument = async (id: number) => {
  try {
    await api.delete(baseUrl + `/providerDocuments/${id}`)
    const listDocument: DocumentsToGet[] = store.getState().Document
      .listDocuments
    store.dispatch(
      setDocuments(listDocument.filter(object => object.id !== id))
    )
    return true
  } catch (err) {
    console.log(err)
    return false
  }
}

export const statusDocument = async (
  documentId: number,
  status: DocumentStatusType
) => {
  const params = {
    id: documentId,
    status
  }

  try {
    await api.put(baseUrl + '/providerDocuments/status', params)
    return true
  } catch (err) {
    console.log(err)
    return false
  }
}
export const postDocumentMessage = async (
  documentId: number,
  message: string
) => {
  const params = {
    id: documentId,
    message
  }
  try {
    await api.post(`${baseUrl}/providerDocuments/message`,params)
    return true
  } catch (err) {
    console.log(err)
    return false
  }
}

export const sendEmail = async (params: DocumentEmailToPost) => {
  try {
    console.log('Envio de e-mail params =', params)
    await api.post(baseUrl + '/emails/custom', params)
    return true
  } catch (err) {
    console.log(err)
    return false
  }
}

export const sendEmailDocumentMissing = async (params: DocumentMissingEmailToPost) => {
  try {
    console.log('Envio de e-mail params =', params)
    await api.post(baseUrl + '/emails/custom/missing', params)
    return true
  } catch (err) {
    console.log(err)
    return false
  }
}

export const getEmailConfig = async () => {
  try {
    const { data } = await api.get(`${baseUrl}/emailConfig`)
    if (data) {
      return data.data.emailConfig
    }
  } catch (err) {
    console.log(err)
    return false
  }
}

export const getDownloadDocument = async (DocumentId: number) => {
  try {
    window.open(`${baseUrl}/providerDocuments/download/${DocumentId}`, '_blank')
  } catch (err) {
    return console.log(err)
  }
}
